import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=1ce69066&"
import script from "./TermList.vue?vue&type=script&lang=js&"
export * from "./TermList.vue?vue&type=script&lang=js&"
import style0 from "./TermList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports